export default function firstPhone(list: string) {
  return list.split(/[,;]/)[0]
}
